import Joi from 'joi';
import { actionCreator, objectSchemaOf } from '../helpers';

export const AUTH = 'AUTH/AUTH';

export interface IAuthPayload {
  token: string;
}

const payloadSchema = objectSchemaOf<IAuthPayload>({
  token: Joi.string().required(),
});

export const authActionSchema = objectSchemaOf<IAuthAction>({
  type: Joi.string().required().valid(AUTH),
  payload: payloadSchema.required(),
});

export interface IAuthAction {
  type: typeof AUTH;
  payload: IAuthPayload;
}

export const auth = actionCreator({
  type: AUTH,
  schema: authActionSchema,
});
